import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'pac-api';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ApiError } from '../../model/api-error';
import { LoggerService } from './../../logger.service';
import { IndividualPhoneModel } from './../../model/individual-phone.model';

@Injectable({
  providedIn: 'root'
})
export class PhoneService {

  constructor(
    private settings: AppSettings,
    private logger: LoggerService,
    private http: HttpClient
  ) {
  }

  public GetPhones(): Observable<IndividualPhoneModel[]> {
    const observable = this.http.get(
      this.settings.pac_base_nf_url + 'api/IndividualPhone',
      { withCredentials: true }
    ).pipe(catchError((err: HttpErrorResponse) => {
      if (err.error.error === true) {
        throw new ApiError(err.error.message, err.error.code || err.status);
      }

      if (err.error) {
        throw err.error;
      }

      if (err.statusText && err.statusText !== 'OK') {
        throw new Error(err.statusText);
      }

      throw err;
    })).pipe(map((result: any) => {
      if (result.error) {
        return result;
      } else if (result instanceof Array) {
        const records = Array<IndividualPhoneModel>();
        for (const record of result) {
          const training = new IndividualPhoneModel(record);
          records.push(training);
        }
        return records;
      }
    }));

    const shared = new Subject<IndividualPhoneModel[]>();
    observable.subscribe(shared);

    return shared;
  }

  public DeletePhone(cph_key: string): Observable<boolean> {
    const observable = this.http.delete(
      this.settings.pac_base_nf_url + 'api/IndividualPhone/' + cph_key,
      { withCredentials: true }
    ).pipe(catchError((err: HttpErrorResponse) => {
      if (err.error.error === true) {
        throw new ApiError(err.error.message, err.error.code || err.status);
      }

      if (err.error) {
        throw err.error;
      }

      if (err.statusText && err.statusText !== 'OK') {
        throw new Error(err.statusText);
      }

      throw err;
    })).pipe(map((result: any) => {
      if (result) {
        return false;
      } else {
        return true;
      }
    }));

    const shared = new Subject<boolean>();
    observable.subscribe(shared);

    return shared;
  }

  public SavePhone(phone: IndividualPhoneModel): Observable<IndividualPhoneModel> {
    let observable: Observable<any>;

    if (phone.cph_key) {
      observable = this.http.put(
        this.settings.pac_base_nf_url + 'api/IndividualPhone/' + phone.cph_key,
        phone,
        { withCredentials: true }
      );
    } else {
      observable = this.http.post(
        this.settings.pac_base_nf_url + 'api/IndividualPhone',
        phone,
        { withCredentials: true }
      );
    }

    observable = observable.pipe(catchError((err: HttpErrorResponse) => {
      if (err.error.error === true) {
        throw new ApiError(err.error.message, err.error.code || err.status);
      }

      if (err.error) {
        throw err.error;
      }

      if (err.statusText && err.statusText !== 'OK') {
        throw new Error(err.statusText);
      }

      throw err;
    })).pipe(map((result: any) => {
      if (result.error) {
        return result;
      } else if ('cph_key' in result) {
        return new IndividualPhoneModel(result);
      }
    }));

    const shared = new Subject<IndividualPhoneModel>();
    observable.subscribe(shared);

    return shared;
  }
}
